<template lang="html">
  <CaseSummaryContainer>
    <Header slot="header" :heading="'Medical Inspection Recommendations'" :methodology="methodology" @print="print">
      <span class="heading subtitle" slot="subtitle">Made to California Correctional Health Care Services</span></Header>
    <PrintArea slot="printArea" :filteredRecommendations="filteredRecommendations" :reportFilter="filter"/>
    <miuRecommendationFilter slot="caseBlockFilter" v-show="filterValues" :recommendations="filteredRecommendations" @applyFilter="applyFilter" :filterValues="filterValues" />
    <miuRecommendationBlock slot="caseBlock" v-for="recommendation in filteredRecommendations" v-bind:key="recommendation.id" :recommendation="recommendation" />
    <b-jumbotron fluid class="text-center" slot="caseBlock" v-show="typeof filteredRecommendations != 'undefined' && !filteredRecommendations.length">There are no recommendations which match your selected filters.</b-jumbotron>
  </CaseSummaryContainer>
</template>
<!-- Global site tag (gtag.js) - Google Analytics -->
<script async src="https://www.googletagmanager.com/gtag/js?id=UA-142178256-1"></script>
<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'UA-142178256-1');
</script>
<script>
import CaseSummaryContainer from '@/components/CaseSummaryContainer.vue'
import Header from '@/components/Header.vue'
import miuRecommendationFilter from '@/components/MIU/components/miuRecommendationFilter.vue'
export default {
  components: {
    Header,
    miuRecommendationBlock: () => import( /* webpackChunkName: 'miuRecommendationBlock' */ '@/components/MIU/components/miuRecommendationBlock.vue'),
    miuRecommendationFilter,
    CaseSummaryContainer,
    PrintArea: () => import( /* webpackChunkName: 'miuPrintArea' */ '@/components/MIU/components/PrintArea.vue')
  },
  data() {
    return {
      filter: {},
      methodology: '<div class="container-fluid"><div class="row"><div class="col">The OIG uses a unique combination of quantitative and qualitative data analysis methods to ensure a thorough assessment of medical care for those individuals within the California Department of Corrections and Rehabilitation, the department, who have the greatest need for medical services. The OIG performs medical inspections in cycles. During each cycle, the OIG inspects medical care at each department adult institution. After each inspection, the OIG publishes a report of each of institution’s medical inspection results. The quantity of recommendations is not necessarily indicative of the overall quality of health care, which can be found in our medical inspection reports. For detailed explanations of our compliance and case review methodology, see below.</div></div><div class="row text-center miuMethodology"><div class="col d-flex justify-content-center col-lg-4 col-md-12 px-0"><button onClick="window.open(\'https://www.oig.ca.gov/dataExplorer/MIU%20Compliance%20Tool.pdf?_t=1604534825\')" class="methodology-toggle elementor-button btn btn-secondary">Compliance Medical Inspection Tool</button></div><div class="col d-flex justify-content-center col-lg-4 col-md-12 px-0"><button onClick="window.open(\'https://www.oig.ca.gov/dataExplorer/MIU%20Case%20Review%20Methodology.pdf\')" class="methodology-toggle elementor-button btn btn-secondary">Case Review Methodology</button></div><div class="col d-flex justify-content-center col-lg-4 col-md-12 px-0"><button onClick="window.open(\'https://www.oig.ca.gov/publications/\')" class="methodology-toggle elementor-button btn btn-secondary">Medical Inspection Reports</button></div></div></div>'
    }
  },
  methods: {
    applyFilter: function(filter) {
      this.filter = filter
    },
    print: function() {
      window.print()
    },
    convertToChosen: (data) => {
      return data.map(d => {
        return {
          'value': d,
          'text': d
        }
      })
    }
  },
  computed: {
    recommendations() {
      return this.$store.getters['miuRecommendations/recommendations']
    },
    filterValues() {
      return this.$store.getters['miuRecommendations/filterValues']
    },
    filteredRecommendations() {
      let filteredList = this.recommendations
      if (Object.keys(this.filter).length === 0) return filteredList
      return filteredList.filter(c => {
        return Object.keys(this.filter).every(f => {
          if (this.filter[f].length === 0) return true
          switch (f) {
            case 'publishYears':
              return this.filter[f].indexOf(new Date(c.publishedDate).getFullYear().toString()) >= 0
            case 'entities':
              return this.filter[f].indexOf(c.entity) >= 0
            case 'cycles':
              return this.filter[f].indexOf(c.cycle) >= 0
            case 'reports':
              return this.filter[f].indexOf(c.report) >= 0
            case 'reportNumbers':
              return this.filter[f].indexOf(c.reportNumber) >= 0
            case 'recommendationNumbers':
              return this.filter[f].indexOf(c.number) >= 0
            case 'indicators':
              return this.filter[f].indexOf(c.indicator) >= 0
            case 'startDate':
              return (this.filter[f] !== null && this.filter[f].toString().length > 0 ? Date.parse(c.publishedDate) >= new Date(this.filter[f]) : true)
              break
            case 'endDate':
              return (this.filter[f] !== null && this.filter[f].toString().length > 0 ? Date.parse(c.publishedDate) <= new Date(this.filter[f]) : true)
              break
          }
        })
      })
    }
  }
}
</script>

<style lang="css">

</style>
